import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, TrashIcon, EditIcon, AddIcon } from 'assets/icons';
import { AdvertisingService } from 'services';
import moment from 'moment';
import ModalCreate from './modal-create';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	status: ''
}

class Advertisements extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Nombre',
			'Url',
			'Banner',
			'Acciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		item: null,
		visible: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Publicidades',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await AdvertisingService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.advertisements.rows,
			last_page: res.advertisements.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	delete = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la publicidad?',async () => {
			await AdvertisingService.admin.delete({
				advertising_id: item?.id
			});	
			Globals.showSuccess("Se ha eliminado la publicidad correctamente");
			this.load(true);
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => {
			this.load(true);
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	changeStatus = async (item: any,index: number) => {
		let data: any = [...this.state.data];
		data[index].status = !item.status;
		this.setState({
			data
		});
		await AdvertisingService.admin.changeStatus({
			advertising_id: item?.id,
			withoutLoading: true
		});
	}

	render() {
		const { visible } = this.state;

		return (
			<div id="admin-advertisements">
				<Modal
		          className="modal-create-advertisement"
		          visible={ visible }
		          title={ `${ this.state.item != null ? 'Editar' : 'Creación de' } publicidad` }
		          onClose={ () => this.onClose() }
		        >
		          <ModalCreate
		          	item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-3">
								<Select
									placeholder="Seleccionar"
									label="Estatus"
									name="status"
									color="white"
									onChange={ (e: any) => this.change(e,() => this.load(true)) }
									value={ this.state.form.status }
									options={ [
										{ value: Constants.ADVERTISEMENTS_STATUS.ACTIVE.toString(), label: 'Activas' },
										{ value: Constants.ADVERTISEMENTS_STATUS.INACTIVE.toString(), label: 'Inactivas' },
									] } />
							</div>
							<div className="col-md-1">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<Table title="Publicidades" data={ this.state.data.length } header={ this.state.header } titleRight={
					<>
						{
							checkPermission(Constants.MODULES.ADVERTISEMENTS,'write') && (
								<div className="container-add-table">
									<p>Nuevo</p>
									<button className="btn add-btn-table" onClick={ this.add }>
										<img src={ AddIcon } />
									</button>
								</div>
							)
						}
					</>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i?.name }</td>
								<td>
									<p className="url">{ i?.url || '-' }</p>
								</td>
								<td>
									{
										i?.banner != null && (
											<img src={ Constants.BASE_STORAGE + i?.banner } className="banner" />
										)
									}
								</td>
								<td style={{ 'whiteSpace': 'nowrap' }}>
									<button className={ `btn btn-toggle ${ i.status ? 'active' : '' }` } onClick={ () => {
										this.changeStatus(i,index);
									} }>
										<div></div>
									</button>
									<Tooltip title="Editar">
										<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
											<img src={ EditIcon } />
										</a>
									</Tooltip>
									<Tooltip title="Eliminar">
										<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
											<img src={ TrashIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Advertisements);